var sgkMenu = {
    state: 'open',
    stateChanged: false,
    currentWidth: 0,
    ref: null,
    el: [],
    msnry: null,

    init: function () {
        sgkMenu.showHide();
        sgkMenu.masonry();
        $(document).on('click', '#sgkNavItmToggle,.sgkBtnMenuClose', sgkMenu.toggle);
        $(window).on('resize', sgkMenu.showHide);

        try {
            // recheck Menue if external fonts loaded
            // only modern browsers: https://caniuse.com/mdn-api_document_fonts
            document.fonts.ready.then(sgkMenu.showHide);
        } catch (e) { }
    },
    toggle: function () {
        $('#sgkMultiRowMenu').addClass('sgkEnableTransition');
        sgkMenu.stateChanged = true;
        if (sgkMenu.state == 'closed') {
            sgkMenu.state = 'open';
            $('#sgkNavItmToggle').addClass('open');
        } else {
            sgkMenu.state = 'closed';
            $('#sgkNavItmToggle').removeClass('open');
        }
        sgkMenu.showHide();
        return false;
    },
    autoHide: function () {
        if (!sgkMenu.stateChanged) {
            sgkMenu.state = 'closed';
            $('#sgkNavItmToggle').removeClass('open');
            sgkMenu.showHide();
        }
    },
    autoShow: function () {
        if (!sgkMenu.stateChanged) {
            sgkMenu.state = 'open';
            $('#sgkNavItmToggle').addClass('open');
            sgkMenu.showHide();
        }
    },
    showHide: function () {
        if (sgkMenu.ref == null) {
            sgkMenu.ref = $('#sgkMultiRowMenu');
            sgkMenu.el = sgkMenu.ref.find('.nav-item > a.nav-link');
        }

        if (sgkMenu.ref.is(':visible')) {
            sgkMenu.currentWidth = sgkMenu.ref.outerWidth();

            var width = 0;
            $.each(sgkMenu.el, function (k, v) {
                width += $(v).outerWidth(true);
                if (sgkMenu.state == 'open' || width <= sgkMenu.currentWidth) {
                    $(v).addClass('sgkShow');
                } else {
                    $(v).removeClass('sgkShow');
                }
            });
        }

        return false;
    },
    masonry: function () {
        sgkMenu.msnry = $('.sgkMasonry').masonry({
            percentPosition: true,
            horizontalOrder: true,
            itemSelector: '.sgkMenuGroup',
            gutter: 12
        });

        $(document).on('shown.bs.dropdown', '#sgkMultiRowMenu .nav-item.dropdown', function () {
            // FIXME sofern wir das weiter nutzen auf Referenz via sgkMenu.msnry umbauen
            $(this).find('.sgkMasonry').masonry('layout');
            if (sgkMenu.state == 'closed') {
                sgkMenu.toggle();
            }
        })
    }
};

$(document).ready(sgkMenu.init);
